import React, {useState} from "react";
import {useParams} from "react-router-dom";
import {Row, Col} from 'reactstrap'
import {useDispatch, useSelector} from 'react-redux';
import Button from "../../../core/buttons/Button";
import {MdKeyboardArrowRight} from 'react-icons/md'
import SelectFacilitiesModal from "../../../components/modals/SelectFacilitiesModal";
import {fetchAllFacilities} from "../../../actions/facilities";
import TableSkeleton from "../../../core/components/skeleton/TableSkeleton";
import ResourcePage from "./ResourcePage";
import {fetchResource} from "../../../actions/resources";
import Card from "../../../core/card/Card";
import CardBody from "../../../core/card/CardBody";
import CardFooter from "../../../core/card/CardFooter";

let ResourceFacilitiesPage = () => {

    let params = useParams();

    let resourceId = params.id

    let resource = useSelector(state => state.resource.byId[resourceId])

    let loading = useSelector(state => state.resource.loadingDetails)

    let dispatch = useDispatch();

    React.useEffect(() => {
        dispatch(fetchAllFacilities())
        dispatch(fetchResource(resourceId, ['facilities']))
    }, [resourceId, dispatch])

    let allFacilities = useSelector(state => state.facility.byId)

    let hasFacilities = resource?.facilities && resource?.facilities.length > 0

    let [selectFacilitiesModalOpened, setSelectFacilitiesModalOpened] = useState(false);

    return <ResourcePage resourceId={resourceId}>
        {selectFacilitiesModalOpened && resource && <SelectFacilitiesModal
            type='resource'
            modalOpened={selectFacilitiesModalOpened}
            setModalOpened={setSelectFacilitiesModalOpened}
            defaultSelected={resource?.facilities}
            objectId={resourceId}
        />}
        <Row className='fitheight'>
            <Col lg={{size: 6, offset: 3}}>
                <Card title='Obiekty'>
                    <CardBody>
                        <table className='data-list'>
                            <tbody>
                            {
                                loading && <TableSkeleton cols={1} rows={3}/>
                            }
                            {
                                !loading && !hasFacilities && <tr>
                                    <td colSpan={3} align='center'>Brak</td>
                                </tr>
                            }
                            {
                                hasFacilities && resource?.facilities.map(facilityId => <tr>
                                    <td>
                                        {allFacilities[facilityId].name}
                                    </td>
                                </tr>)
                            }
                            </tbody>
                        </table>
                    </CardBody>
                    <CardFooter>
                        <Button text='Wybierz obiekty'
                                  variant='forward'
                                  onClick={() => setSelectFacilitiesModalOpened(() => true)}
                                  Icon={MdKeyboardArrowRight} rightIcon={true}/>
                    </CardFooter>
                </Card>
            </Col>
        </Row>
    </ResourcePage>

}

export default ResourceFacilitiesPage
